import { createStyles } from "@mantine/core";

export default createStyles ( ( theme, props ) => {

	return {
		typography: {
			color         : props?.color === "secondary" ? theme.other.colors.text.secondary : theme.other.colors.text.primary,
			textTransform : "none",
			fontSize      : "1.5rem"
		}
	};
} );